"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
var __1 = require("../../..");
var hooks_1 = require("../../../hooks");
var useDebounce_1 = __importDefault(require("../../../hooks/useDebounce"));
var components_1 = require("../components");
var Label_1 = __importDefault(require("../components/Label"));
var Input_1 = __importDefault(require("../inputs/Input"));
var CisloPolozkyUkonuField = function (_a) {
    var name = _a.name, idDruhNavazny = _a.idDruhNavazny, label = _a.label, placeholder = _a.placeholder, isEditMode = _a.isEditMode, onChange = _a.onChange;
    var _b = formik_1.useField(name), field = _b[0], meta = _b[1], helpers = _b[2];
    var value = field.value || '';
    var _c = react_1.useState(), loading = _c[0], setLoading = _c[1];
    var _d = react_1.useState(), check = _d[0], setCheck = _d[1];
    var ukonyUrl = __1.useConfig().ukonyUrl;
    var getJSON = hooks_1.useGetJSON(ukonyUrl + "/CheckCisloPolozky");
    var validPolozka = new RegExp('[0-9]+[//][0-9]+');
    var isValid = hooks_1.useBoolean(false);
    var debouncedValue = useDebounce_1.default(value).debouncedValue;
    var existuje = hooks_1.useBoolean(true);
    var checkCisloPolozky = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, getJSON({ cisloPolozky: value, idDruhNavazny: idDruhNavazny })];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (__1.isRight(response)) {
                        onChange(response.value.existuje);
                        existuje.setValue(response.value.existuje);
                        return [2 /*return*/, setCheck(response.value.existuje && response.value.validni)];
                    }
                    existuje.setTrue();
                    setCheck(false);
                    return [2 /*return*/];
            }
        });
    }); };
    react_1.useEffect(function () {
        if (isValid.value)
            checkCisloPolozky();
    }, [debouncedValue]);
    var handleChange = function (e) {
        var val = e.target.value.replace(/[^0-9//]/g, '');
        helpers.setValue(val);
        setCheck(undefined);
    };
    var handleValid = function (blur) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (validPolozka.test(value)) {
                return [2 /*return*/, isValid.setTrue()];
            }
            isValid.setFalse();
            onChange(true);
            if (blur)
                setCheck(false);
            return [2 /*return*/];
        });
    }); };
    return (react_1.default.createElement(components_1.Field, null,
        react_1.default.createElement(Label_1.default, null, label),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Input_1.default, __assign({}, field, { value: value, name: name, hasError: !!meta.error, onKeyUp: function () { return handleValid(); }, loading: loading, check: value.length ? check : undefined, onBlur: function () { return handleValid(true); }, onChange: handleChange, onWheel: function (e) { return e.target.blur(); }, placeholder: placeholder, readOnly: isEditMode, maxLength: 15, closeBlack: !existuje.value })))));
};
CisloPolozkyUkonuField.defaultProps = {
    placeholder: undefined,
    isEditMode: undefined,
};
exports.default = CisloPolozkyUkonuField;
